import { Checkbox, FormControlLabel, Text } from "designSystem/index";
import React, { useState } from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => {
	const [checked, setChecked] = useState(false);

	const onChange = (event: object, value: boolean) => {
		setChecked(value);
	};

	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="Labeled Checkbox" />
			<Text semiBold text="Disabled Labeled Checkbox" />
			<Checkbox
				checked={checked}
				labelProps={{
					label: "End Label",
				}}
				onChange={onChange}
			/>
			<Checkbox
				checked={checked}
				disabled
				labelProps={{
					label: "End Label",
				}}
				onChange={onChange}
			/>
		</CssColumnGrid>
	);
};
